export const breakpoints = {
  xl: 1450,
  lg: 1320,
  md: 990,
  sm: 768,
  xs: 575
}
